<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>

  <!-- Form -->
  <form @submit.prevent="store" class="form-content" style="height: 90vh">
    <div class="form-content-inner">
      <control
        type="hidden"
        v-model="progexctimecomm.id"
        :hasError="!!errors.id"
        id="id"
      />
      <div class="form-col">
        <field
          :label="$t('progexctimecomm.employee_name')"
          class="w-full md:ml-2 mb-2 md:mb-0"
          :hasError="errors.employee_id"
        >
          <multiselect
            ref="employeSelect"
            v-model="selected"
            :options="employeeList"
            label="name"
            :close-on-select="false"
            placeholder="Select users"
            @select="onSelect"
            mode="tags"
            trackBy="value"
            :searchable="true"
          />
        </field>
      </div>

      <div
        class="buttons-submit transition-colors duration-1000"
        :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'"
      >
        <jb-buttons class="buttons-action-submit">
          <jb-button
            type="submit"
            color="info"
            :icon="mdiCheckBold"
            :label="$t('finance.button.btnSubmit')"
            class="form-submit-btn"
          />
          <jb-button
            type="button"
            color="info"
            outline
            :label="$t('finance.button.btnReset')"
            class="form-noicon-btn btn-reset"
            @click="reset()"
          />
        </jb-buttons>
      </div>
    </div>
  </form>
</template>

<script>
/* eslint-disable */
import {
  ref,
  reactive,
  onMounted,
  onBeforeMount,
  watch,
  watchEffect,
  computed,
} from "vue";
import axios from "axios";
import { mdiBallot, mdiCheckBold } from "@mdi/js";
import Control from "@/components/Control";
import JbButton from "@/components/JbButton";
import JbButtons from "@/components/JbButtons";
import Multiselect from "@vueform/multiselect";
import Field from "@/components/Field";
import { useToast } from "vue-toastification";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { on } from "events";

export default {
  name: "ProgexctimeForm",
  components: {
    Field,
    Control,
    Loading,
    JbButton,
    Multiselect,
    JbButtons,
  },
  props: {
    showEdit: {
      type: Boolean,
      default: false,
    },
    propClass: {
      type: Object,
      default: () => ({ empty: true }),
    },
    progexctimeId: {
      type: String,
      default: "",
    },
  },
  emits: ["close-modal", "submit", "reset-modal"],

  setup(props, { emit }) {
    const titleStack = ref(["Admin", "Forms"]);
    const isLoading = ref(false);
    const toast = useToast();
    const router = useRouter();
    const errors = ref({});
    const str = useStore();
    const userlogin = localStorage.getItem("name");

    const selected = ref([]);
    const employeeSelect = ref(null);
    const progexctimeList = ref([]);
    const employeeList = ref([]);

    const progexctimecomm = reactive({
      id: "",
      programme_exception_time_id: "",
      employee_id: [],
    });

    const reset = () => {
      // progexctimecomm.programme_exception_time_id = ''
      progexctimecomm.employee_id = [];
    };

    const store = async () => {
      isLoading.value = true;
      const url = props.showEdit
        ? "progexctimecomm/" + progexctimecomm.id
        : "progexctimecomm";
      const method = props.showEdit ? "PUT" : "POST";
      if (method === "POST") {
        progexctimecomm.created_by = userlogin;
        progexctimecomm.employee_id = selected.value;
      } else {
        progexctimecomm.updated_by = userlogin;
      }

      const jsonData = JSON.stringify(progexctimecomm);
      const configHeaders = {
        "content-type": "application/json",
        Accept: "application/json",
      };
      await axios({
        method,
        url,
        data: jsonData,
        headers: configHeaders,
      })
        .then((response) => {
          if (response.data.success) {
            emit("reset-modal");
            emit("close-modal");
            toast.success(response.data.message);
          } else {
            errors.value = response.data.messages;
            toast.error(response.data.messages);
          }
          isLoading.value = false;
          reset();
        })
        .catch((error) => {
          if (error.response) {
            console.log(error);
            toast.error(error.response.data.message);
            console.log(JSON.stringify(error.request));
          } else if (error.message) {
            console.log(error.message);
            toast.error(error.message);
            console.log(JSON.stringify(error.message));
          }
          isLoading.value = false;
        });
    };

    const getProgrammeExceptionTime = async () => {
      isLoading.value = true;
      await axios
        .get("progexctime")
        .then((response) => {
          progexctimeList.value = response.data.data;
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data, { timeout: 5000 });
          console.log(error);
          isLoading.value = false;
        });
    };

    const getEmployee = async () => {
      isLoading.value = true;
      const userId = localStorage.getItem("user_id");
      const branchId = localStorage.getItem("branch_id");
      const params = {
        user_id: userId,
        branch_id: branchId,
      };
      await axios
        .get("employee", {params})
        .then((response) => {
          isLoading.value = false;
          const data = response.data.data;
          employeeList.value = [
            { value: "__all__", name: "Select All" },
            ...data.map((emp) => ({
              value: emp.id,
              name: emp.name,
            })),
          ];
        })
        .catch((error) => {
          toast.error(error.response.data, { timeout: 5000 });
          console.log(error);
          isLoading.value = false;
        });
    };

    const normalizedEmployees = computed(() => {
      const base = employeeList.value.map((emp) => ({
        value: emp.value, // assume API returns `id`
        name: emp.name, // and `name`
      }));
      if (progexctimecomm.employee_id === "__all__") {
        return [{ value: "__all__", name: "Select All" }, ...base];
      }
      return base;
    });

    // Select All logic
    const onSelect = (option) => {
      console.log("option.value", option);
      if (option === "__all__") {
        console.log("normalizedEmployees", normalizedEmployees.value);
        selected.value = normalizedEmployees.value
          .filter((opt) => opt.value !== "__all__")
          .map((opt) => opt.value);
      }
    };

    onBeforeMount(() => {});

    onMounted(() => {
      getProgrammeExceptionTime();
      getEmployee();
    });

    watch(
      () => props.progexctimeId,
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          progexctimecomm.programme_exception_time_id = newVal;
        }
      }
    );

    watchEffect(
      () => props.propClass,
      (newVal) => {
        const newProgexctimecomm = props.propClass;
        Object.assign(progexctimecomm, newProgexctimecomm);
      }
    );

    return {
      isLoading,
      titleStack,
      progexctimeList,
      employeeList,
      mdiBallot,
      mdiCheckBold,
      router,
      getProgrammeExceptionTime,
      getEmployee,
      progexctimecomm,
      store,
      toast,
      userlogin,
      errors,
      reset,
      str,
      onSelect,
      selected,
      employeeSelect,
      normalizedEmployees,
      // employeeOptions,
    };
  },
  methods: {
    clearForm() {
      this.progexctimecomm = reactive({
        id: "",
        programme_exception_time_id: "",
        employee_id: [],
        created_by: "",
      });
    },
    onChange: function (programme_exception_time_id, event) {
      if (event.target.value) {
        programme_exception_time_id = event.target.value;
      }
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
